import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import * as selectors from '@/models/notifies/selectors'
import dayjs from 'dayjs';
import { Button, Table, Badge, Divider, Tabs } from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/notifies/actions';
import styles from './notifies.module.scss';
import OperationNotifie from './OperationNotifie'
import Feedback from './Feedback'
import { getCurrentUser } from '@/models/user/selectors';

function getColumns({ fetch }) {
  const dispatch = useDispatch()

  const showInfoDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showInfoDialog({
      notify: item,
      title: '编辑消息',
      ismodify: "modify",
      disabled: false,
      review: false,
      submitCallback: () => { fetch() }
    }))
  })
  const deleteNotify = useCallback((item, callback) => event => {
    event.preventDefault()
    dispatch(actions.deleteNotify(item._id, callback))
  })
  const sendNotify = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showSendNotifyDialog({
      notify: item,
      title: '发送消息'
    }))
  })
  const sendHistory = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showSendHistoryDialog({
      notify: item,
      title: '发送历史'
    }))
  })
  return [
    {
      key: '_id',
      title: '编号',
      width: 60,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '标题',
      width: 200,
      render: item => (
        <div>{item.title}</div>
      )
    },
    {
      title: '内容',
      render: item => (
        <div>
          <div>{item.content}</div>
        </div>
      )
    },
    {
      title: '创建时间',
      width: 180,
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD  HH:mm:ss') : '-'}
        </div>
      )
    },
    {
      title: '操作',
      width: 280,
      render: item => {
        return (
          <div>
            <a onClick={showInfoDialog(item)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={deleteNotify(item, fetch)}>删除</a>
            <Divider type="vertical" />
            <a onClick={sendNotify(item)}>发送消息</a>
            <Divider type="vertical" />
            <a onClick={sendHistory(item)}>发送历史</a>
          </div>
        )
      }
    }
  ]
}
//消息管理
function Notifies(props) {
  const dispatch = useDispatch()
  const { query, history, match, location } = props
  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const notifies = useSelector(selectors.entriesSelectors)
  const noDoFeedbackNum = useSelector(selectors.noDoFeedbackNum)
  const user = useSelector(getCurrentUser);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [activeKey, setActiveKey] = useState('1');

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    dispatch(actions.fetchList(params))
    setLimit(params.limit)
    setOffset(params.offset)
  }, [])
  const showInfoDialog = useCallback((title) => () => {
    dispatch(actions.showInfoDialog({
      title,
      notify: {},
      review: false,
      submitCallback: () => { fetch(query) }
    }))
  }, [query])

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      // ...query,
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    window.scrollTop = 0
    // history.push(`/notifies?${qs.stringify(nextQuery)}`)
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch })

  useMount(() => {
    fetch(query)
  })

  const operations = (<>
    {activeKey == 1 && user.get('isAdmin') && <Button size="small" onClick={showInfoDialog('添加消息')}>添加消息</Button>}

  </>)
  return (<div className={styles.container}>
    <Tabs
      type="card"
      activeKey={activeKey}
      tabBarExtraContent={operations}
      onChange={(key) => {
        setActiveKey(key)
      }}>
      <Tabs.TabPane tab="通知消息" key="1">
        <Table
          className={styles.table}
          columns={columns}
          rowKey="_id"
          dataSource={notifies.toJS()}
          pagination={pagination}
          onChange={handleTableChange}
          loading={loading}
        ></Table>
      </Tabs.TabPane>
      <Tabs.TabPane tab="操作通知" key="2">
        <OperationNotifie />
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <>
          意见反馈
          <Badge count={noDoFeedbackNum}
            style={{ marginRight: 5, transform: 'scale(0.8)', boxShadow: 'none' }}
          />
        </>
      } key="3">
        <Feedback />
      </Tabs.TabPane>
    </Tabs>
    {/* <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>消息管理</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
        <Button size="small" onClick={showInfoDialog('添加消息')}>添加消息</Button>
      </div> */}
  </div>
  );
}
export default Notifies